const ORGINAL_SIZE_REGEX = /width=\d+|w=\d+|h=\d+|&width=\d+|&w=\d+|&h=\d+|func=\w+|\?$/g;
const AND_SYMBOL_REGEX = /\?&/g;


export {
  ORGINAL_SIZE_REGEX,
  AND_SYMBOL_REGEX,
};
